var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateCursor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.39111 12.3992C1.8786 13.3327 0.83569 14.565 0.665054 15.9971C0.481929 17.5341 1.34213 18.9283 2.78277 19.9931C4.22569 21.0596 6.27708 21.8302 8.59853 22.2329C9.00665 22.3037 9.39489 22.0302 9.46568 21.6221C9.53648 21.214 9.26303 20.8257 8.85491 20.7549C6.67879 20.3774 4.87089 19.6712 3.67434 18.7868C2.4755 17.9008 2.05907 16.9757 2.15452 16.1746C2.22802 15.5577 2.61778 14.879 3.40213 14.2282C3.39485 14.1648 3.39111 14.1004 3.39111 14.0352V12.3992ZM15.9348 12.049C16.08 12.0742 16.2242 12.1011 16.3673 12.1295L15.9348 11.8823V12.049ZM21.3911 14.2382C21.4369 14.2763 21.4815 14.3148 21.5249 14.3535C22.5326 15.2508 22.7926 16.1513 22.5614 16.9517C22.3111 17.8181 21.438 18.7624 19.8363 19.5483L19.82 19.5566L15.2472 21.9409L15.1367 20.9196C15.0922 20.5077 14.7223 20.21 14.3104 20.2546C13.8986 20.2991 13.6009 20.6691 13.6454 21.0809L13.8618 23.0809C13.9037 23.4688 14.2362 23.7598 14.6263 23.75L14.7628 23.7465C14.825 23.7528 14.8883 23.7514 14.9513 23.7418L20.41 23.6042C20.8241 23.5938 21.1513 23.2497 21.1409 22.8356C21.1304 22.4215 20.7863 22.0943 20.3722 22.1047L18.066 22.1628L20.5055 20.8908C22.2736 20.0215 23.5836 18.8181 24.0025 17.368C24.4412 15.8494 23.818 14.3869 22.5225 13.2333C22.1879 12.9353 21.8088 12.6569 21.3911 12.3993V14.2382Z",
    fill: "#DDDEE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58984 4.2V17L9.18984 13.8L15.5898 17L21.1898 13.8V1L15.5898 4.2L9.18984 1L3.58984 4.2Z",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19141 1V13.8",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5898 4.2002V17.0002",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateCursor);
export default __webpack_public_path__ + "static/media/rotate_cursor.ae45c914d7597c060d8fcb0a5c77d3dc.svg";
export { ForwardRef as ReactComponent };